import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { AppMainService } from 'src/app/app-main.service';
import { DocumentViewerService } from '../../services/document-viewer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Severity } from 'src/app/inventory/constants/constants';
import { TitleCasePipe } from '@angular/common';
import { DocumentPayload, GetAllAccountDocument, GetAllLeadDocument } from '../../models/documents/document.model';
import { AccountModuleId, LeadModuleId } from '../../constants/modules.constant';
import { LeadDocumentService } from 'src/app/leads-v2/services/lead-document.service';
import { environment } from 'src/environments/environment';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { FileUpload } from 'primeng/fileupload';
import { Table } from 'primeng/table';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-documents-management',
  templateUrl: './documents-management.component.html',
  styleUrl: './documents-management.component.scss'
})
export class DocumentsManagementComponent implements OnInit, OnChanges, OnDestroy {
  // properties from Module
  @Input() selectedData: any;  //selectedData contains selected Account or Lead Details
  @Input() selectedModuleId: number;
  @Input() selectedChannel: any;
  @Input() displayDocumentList: boolean = false;
  @Input() fromActionButton: boolean = false;

  documentsList: any[] = [];
  first: number = 0;
  pageNumber: number = 1;
  pageSize: number = 5;
  totalRecords: number = 0;
  displayNewUpload: boolean = false;
  loading: boolean = true;
  files = [];
  newFileList: File[] = [];
  saveBtn: string = '';
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.txt', '.xls', '.xlsx', 'csv', '.doc', '.docx', '.ppt', '.pptx', 'pdf','jfif'];
  totalFileSize = 0;
  fileList: File[] = [];
  maxFilesizeErrorMessage = [];
  maxNoOfFilesErrorMessage = [];
  specialCharacterErrorMsg = [];
  // Initialize with default values
  tempDuc: DocumentPayload = {
    attachmentId: 0,
    idNo: '',
    name: '',
    uploadedDate: '',
    uploadedBy: ''
  };
  erorMesg: any[] = [];
  tooltipText =  `Notes:
  1. Allowed file extensions: ${this.allowedExtensions.join(', ')}.
  2. You can upload up to 3 files at a time.
  3. The total size of all selected files should not exceed 25MB.`;

  @ViewChild('documentTable') table: Table;
 /** Subscription and Cleanup */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  displayFilePreview: boolean = false;
  currentFile: any;

  constructor(
    public appMainService: AppMainService,
    private messageService: MessageService,
    private accountServiceN: AccountServiceN,
    private leadDocumentService: LeadDocumentService,
    private documentViewerService: DocumentViewerService,
    private titlecasePipe: TitleCasePipe,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    //this.getAllDocumentsList();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.selectedData && changes.selectedData.currentValue) {
      this.selectedData = changes.selectedData.currentValue;
      this.resetpageState();
    }

    if (changes.displayDocumentList && changes.displayDocumentList.currentValue) {
      this.displayDocumentList = changes.displayDocumentList.currentValue;
    }

    if (changes.selectedModuleId && changes.selectedModuleId.currentValue) {
      this.selectedModuleId = changes.selectedModuleId.currentValue;
    }

  }

  resetpageState() {
    if (this.table) {
      this.table.reset(); // This will reset the pagination and sorting
    }
    this.pageNumber = 1;
    this.pageSize = 5;
    this.totalRecords = 0;
    this.first = 0;
  }

  getAllDocumentsWithPagination(event?: LazyLoadEvent) {
    if (event) {
      this.pageSize = event.rows;
      this.pageNumber = (event.first / event.rows) + 1;
    }
    else {
      this.pageSize = 5;
      this.pageNumber = 1;
    }
    if(this.selectedData){
     this.getAllDocumentsList();
    }

  }

  //#region FetchAllDocList
  getAllDocumentsList() {
    let documentPayload: any;
    if (this.selectedModuleId == AccountModuleId) {
      documentPayload = this.prepareAccountRequestData();
    } else if (this.selectedModuleId == LeadModuleId) {
      documentPayload = this.prepareLeadRequestData();
    }
    this.loading = true;
    const apiCall = this.selectedModuleId == AccountModuleId
      ? this.accountServiceN.getAccountDocumentList(documentPayload)
      : this.leadDocumentService.getLeadDocumentList(documentPayload);
    apiCall.pipe(
            takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (data) => {
        this.documentsList = data?.body || [];
        const headers = data?.headers ? JSON.parse(data.headers.get('x-pagination')) : null;
        this.totalRecords = headers?.TotalCount || 0;
        this.loading = false;
        this.appMainService.isHideSpinner('getAccountDocumentList');
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
        this.appMainService.isHideSpinner('getAccountDocumentList');
      }
    })
  }
  //#endregion FetchAllDocList

  //#region DocumentsCRUD
  addUpload() {
    this.saveBtn = 'upload';
    this.removeAllFiles();
    this.displayNewUpload = true;
    this.newFileList = [];
  }

  uploadAttachments(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        const isFileAlreadyUploaded = this.fileList.some(el => el.name === file.name);
        if (isFileAlreadyUploaded) {
          // File is already selected
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${file.name} is already selected. Please choose a different file.`
          });
        } else {
          let errors = validateFiles(file, 25, this.allowedExtensions);

          if (errors.length > 0) {
            for (let error of errors) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.fileName + ": " + error.error
              });
            }

            this.appMainService.isHideSpinner('upload');
          } else {
            this.newFileList.push(file);
            uploadFiles(file, ({ size }) => {
              this.totalFileSize += size;
              if (this.totalFileSize >262144001) {
                this.maxFilesizeErrorMessage = [
                  { severity: 'info', summary: 'Info', detail: 'Max File size should be less than 25Mb' }
                ];
              } else {
                this.fileList.push(file);
                this.maxFilesizeErrorMessage = [];
              }
              this.appMainService.isHideSpinner('upload');
            });
          }
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
    this.appMainService.isHideSpinner('upload');
    if (this.newFileList.length > 3) {
      this.maxNoOfFilesErrorMessage = [
        { severity: 'info', summary: 'Info', detail: 'You can only upload 3 files in one go' }
      ];
    } else {
      this.maxNoOfFilesErrorMessage = []; // Remove the error message
    }
  }

  removeAllFiles() {
    this.fileList = [];
    this.files = [];
    this.newFileList = [];
    this.totalFileSize = 0;
    this.maxFilesizeErrorMessage = [];
    this.maxNoOfFilesErrorMessage = [];
  }

  editUpload(document) {
    this.saveBtn = 'edit';
    this.displayNewUpload = true;
    this.tempDuc = JSON.parse(JSON.stringify(document));
  }

  editDocument() {
    let newName: string[] = this.tempDuc?.name.split(".");
    this.appMainService.isShowSpinner('editDocument');
    let requestBody: {
      attachmentId: number,
      name: string
    } = {
      attachmentId: this.tempDuc?.attachmentId,
      name: newName[0]
    }
    const apiCall = this.selectedModuleId == AccountModuleId
      ? this.accountServiceN.editAccountDocument(requestBody)
      : this.leadDocumentService.editLeadDocument(requestBody);
    apiCall.pipe(
      takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (data) => {
        if (data?.isSuccessful) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data?.message
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error!',
            detail: data?.message
          });
        }
        this.getAllDocumentsList();
        this.displayNewUpload = false;
        this.appMainService.isHideSpinner('editDocument');

      },
      error: (error) => {
        this.appMainService.isHideSpinner('editDocument');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }

   openFilePreview(event, docuemnt) {
    event.stopPropagation();
    this.previewFile(docuemnt);
  }

  previewFile(docuemnt) {
    this.appMainService.isShowSpinner('openFilePreview');
    let docType: string = docuemnt?.extension;
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: docuemnt?.attachmentId,
      isDefaultContentType: false
    }
    const apiCall = this.selectedModuleId == AccountModuleId
      ? this.accountServiceN.downloadFilesAndFolder(requestBody)
      : this.leadDocumentService.downloadFilesAndFolder(requestBody);
    apiCall.pipe(
      takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (data) => {
        const fileUrl = data?.downloadLink;
        if (fileUrl) {
          this.documentViewerService.previewDocument(docType, data);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
        }

        this.appMainService.isHideSpinner('openFilePreview');
      },
      error: (error: HttpErrorResponse) => {
        this.appMainService.isHideSpinner('openFilePreview');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    })
  }

  getFileIcon(fileName: string): string {
    const seperationIndex = fileName.lastIndexOf(".");
    const extension = fileName.substring(seperationIndex + 1).toLowerCase();
    return `${environment.assestsBasePath}icons/${extension}.png`;
  }

  //#region SaveDocument
  save(fileUpload) {
      if (this.newFileList.length > 3) {
        this.maxNoOfFilesErrorMessage = [
            { severity: 'info', summary: 'Info', detail: 'You can only upload 3 files in one go' }
        ];
        return; // Stop further execution
    } else {
        this.maxNoOfFilesErrorMessage = []; // Remove the error message
    }
    this.fileList.forEach((file: File, index: number) => {
      this.erorMesg[index] = this.checkSpecialCharacterInString(file?.name);
    })
    if (this.erorMesg.filter(data => data == true).length > 0) {
      this.specialCharacterErrorMsg = [
        { severity: 'info', summary: 'Info', detail: 'A file name can not contain any of the character % * <> ? | :' }
      ];
      return
    }
    let found: File[];

    this.appMainService.isShowSpinner('accountsDocumentUpload');
    const requestBody = this.createPayload();
    if (this.documentsList == null) {
      this.documentSave(requestBody, fileUpload);
    } else {
      found = this.documentsList.filter((data) => {
        return this.fileList.find((item) => {
          return item?.name == data?.name
        })
      });
      if (found.length != 0) {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'This Document name is already exist.'
        });
      } else {
        this.documentSave(requestBody, fileUpload)
      }
    }
  }

  documentSave(requesBody, fileUpload) {
    const apiCall = this.selectedModuleId == AccountModuleId
      ? this.accountServiceN.accountsDocumentsUpload(requesBody)
      : this.leadDocumentService.leadsDocumentsUpload(requesBody);
    apiCall.pipe(
      takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        this.displayNewUpload = false;
        if (this.erorMesg?.length > 0) {
          this.specialCharacterErrorMsg = [];
          this.erorMesg = [];
        }
        fileUpload?.clear();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document is successfully uploaded!!'
        });
        this.documentsList = [];
        this.getAllDocumentsList();
      },
      error: (error) => {
        this.appMainService.isHideSpinner('accountsDocumentUpload');
        if (error.status === 413) {
          this.messageService.add({
              severity: 'error',
              summary: 'Upload Failed!',
              detail: 'The total file size exceeds the allowed limit (25MB). Please upload smaller files.'
          });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      }
      },
    })
  }
  //#endregion SaveDocument

  checkSpecialCharacterInString(inputString): any {
    const specialCharacterPattern = /[\/\\?*"<>\|:%\x00-\x1F]/;
    const myArray: string[] = inputString.split(".");
    return specialCharacterPattern.test(myArray[0]);
  }
  //#region DeleteDoc
  delUpload(product) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this document?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        const apiCall = this.selectedModuleId == AccountModuleId
          ? this.accountServiceN.deleteAccountDocument(product?.attachmentId)
          : this.leadDocumentService.deleteLeadDocument(product?.attachmentId);
        this.appMainService.isShowSpinner('deleteAccountDocument');
        apiCall.pipe(
          takeUntil(this.ngUnsubscribe$)).subscribe({
          next: (data) => {
            this.documentsList = [];
            this.getAllDocumentsList();
            this.appMainService.isHideSpinner('deleteAccountDocument');
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Document is successfully Deleted.'
            });
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteAccountDocument');
            this.messageService.add({
              severity: 'error',
              summary: 'Error!',
              detail: 'Error occurring when loading accounts. Please try after sometime.'
            });
          },
        })
      },
      reject: () => {
      }
    });
  }
  //#endregion DeleteDoc

  //#region DownloadLink
  downloadLink(product) {
    this.appMainService.isShowSpinner('downloadLink');
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: product?.attachmentId,
      isDefaultContentType: true
    }
    const apiCall = this.selectedModuleId == AccountModuleId
      ? this.accountServiceN.downloadFilesAndFolder(requestBody)
      : this.leadDocumentService.downloadFilesAndFolder(requestBody);
    apiCall.subscribe({
      next: (data) => {
        this.downloadedFile(data?.downloadLink);
        this.appMainService.isHideSpinner('downloadLink');
      },
      error: (error: HttpErrorResponse) => {
        this.appMainService.isHideSpinner('downloadLink');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    })

  }

  downloadedFile(url: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = 'todo-1.json';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }
  //#endregion DownloadLink

  //#region DocumentPayload
  createPayload(): FormData {       //While saving Document
    const formData = new FormData();
    formData.append('ChannelId', this.selectedChannel?.id);
    formData.append('ChannelName', this.selectedChannel?.name);
    if (this.selectedModuleId === AccountModuleId) {
      formData.append('AccountId', this.selectedData?.id);
      formData.append('AccountName', this.selectedData?.businessName);
    } else if (this.selectedModuleId === LeadModuleId) {
      formData.append('LeadId', this.selectedData?.id);
      formData.append('LeadName', this.selectedData?.businessName);
    }
    // Attach files
    this.fileList.forEach(file => {
      formData.append('Files', file);
    });

    return formData;
  }

  prepareAccountRequestData(): GetAllAccountDocument {
    return {
      AccountId: this.selectedData?.id,
      AccountName: this.selectedData?.businessName,
      LeadId: this.selectedData?.leadId,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize
    }
  }

  prepareLeadRequestData(): GetAllLeadDocument {
    return {
      LeadId: this.selectedData?.id,
      LeadName: this.selectedData?.businessName,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize
    };
  }

  refreshDocuments() {
    this.getAllDocumentsList();
  }

  removeFromUpload(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
    this.totalFileSize = this.totalFileSize - file.size
    this.fileList = [];
    this.newFileList = [];
    for (let file of uploader.files) {
      this.fileList.push(file);
      this.newFileList.push(file);
    }
    if (uploader.files.length < 4) {
      this.maxNoOfFilesErrorMessage = [];
    }
    if (this.totalFileSize < 262144001) {
      this.maxFilesizeErrorMessage = [];
    }
    if (this.erorMesg.length > 0) {
      this.specialCharacterErrorMsg = [];
      this.erorMesg = [];
    }
  }

  closeFilePreview(){
    this.displayFilePreview = false;
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
}
